import {TColumnCount} from 'components/Grid/types';

export const COLUMNS_COUNT_MD: TColumnCount = 3;
export const COLUMNS_COUNT_SM: TColumnCount = 6;
